
import 'regenerator-runtime/runtime';
import OverAllReport from "./components/OverAllReport.js";
import SystemProvider from "./service/SystemProvider";

class App extends React.Component {
	constructor(props) {
		super(props);
    
		this.state = {
			
		}
	}

	render() {
		return (<div> 
			<SystemProvider>
			<OverAllReport />
			</SystemProvider>
		</div>);
	}
}

ReactDOM.render(<App />, document.getElementById("reactblock"));